import { jsx as _jsx } from "react/jsx-runtime";
import { IconButton, TooltipHost, } from '@fluentui/react';
/**
 * A Fluent UI `IconButton` enhanced with a tooltip.
 *
 * This implementation is based on the "Icon Button with Tooltip" example
 * on [Fluent UI React Button page](https://developer.microsoft.com/en-us/fluentui/#/controls/web/button).
 */
const IconTooltipSimple = ({ ariaLabel, ariaDescription, parentLabel, content, iconName = 'info', }) => {
    return (_jsx(TooltipHost, Object.assign({ content: content }, { children: _jsx(IconButton, { "aria-label": 'tooltip ' +
                (ariaLabel && parentLabel ? parentLabel + ariaLabel : ariaLabel), ariaDescription: ariaDescription, iconProps: {
                iconName,
                styles: {
                    root: {
                        fontSize: '12px',
                    },
                },
            } }) })));
};
// Exports
// -------
export { IconTooltipSimple };
